"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContainerMobile = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./Container.css"));
var _utils = require("@cian/utils");
var _mortgageLink = require("../../constants/mortgageLink");
var _constants = require("../../constants");
var _assets = require("../../assets");
var _ContentContainer = require("../ContentContainer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ContainerMobile = _ref => {
  let {
    fields,
    minRate,
    minPayment,
    programs,
    title,
    onMortgageButtonClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['inner']
  }, /*#__PURE__*/React.createElement(_ContentContainer.ContentContainer, null, /*#__PURE__*/React.createElement("img", {
    src: _assets.logo,
    height: 32
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['offset-top-16']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading2, null, title)), /*#__PURE__*/React.createElement("div", {
    className: styles['offset-top-16']
  }, fields), minRate > 0 && minPayment > 0 && /*#__PURE__*/React.createElement("div", {
    className: styles['offset-top-16']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['row']
  }, ['Ставка', 'Платеж в месяц'].map(header => /*#__PURE__*/React.createElement(_uiKit.ArticleParagraph2, {
    color: "gray60_100",
    key: header
  }, header))), /*#__PURE__*/React.createElement("div", {
    className: styles['row']
  }, /*#__PURE__*/React.createElement(_uiKit.ArticleHeading2, null, "\u043E\u0442 ", minRate, "%"), /*#__PURE__*/React.createElement(_uiKit.ArticleHeading2, null, "\u043E\u0442 ", (0, _utils.numberToPrettyString)(minPayment), " \u20BD")))), /*#__PURE__*/React.createElement("div", {
    className: styles['offset-top-24']
  }, programs), /*#__PURE__*/React.createElement(_ContentContainer.ContentContainer, null, /*#__PURE__*/React.createElement("div", {
    className: styles['offset-top-16']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u0438\u043F\u043E\u0442\u0435\u043A\u0443 \u0431\u0435\u0437", _constants.NBSP, "\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432")), /*#__PURE__*/React.createElement("div", {
    className: styles['offset-top-16']
  }, /*#__PURE__*/React.createElement(_uiKit.LinkButton, {
    theme: "fill_success_primary",
    fullWidth: true,
    href: _mortgageLink.MORTGAGE_LINK,
    onClick: onMortgageButtonClick,
    size: "M"
  }, "\u041F\u043E\u0434\u0430\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443 \u043E\u043D\u043B\u0430\u0439\u043D")), /*#__PURE__*/React.createElement("div", {
    className: styles['offset-top-16']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: "gray60_100"
  }, "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u043E\u0441\u0438\u0442 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440 \u0438 \u043D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u0444\u0435\u0440\u0442\u043E\u0439"))));
};
exports.ContainerMobile = ContainerMobile;